<div class="modal-header"><h2 class="modal-title">Pledge</h2></div>
<div class="modal-body">
  @if (pledge) {
    <div>
      <dx-form [formData]="pledge" validationGroup="statusChangeData" [colCount]="2">
        <dxi-item
          dataField="personId"
          [colSpan]="2"
          [label]="{ text: 'Person' }"
          [editorType]="'dxSelectBox'"
          [editorOptions]="{ items: people, valueExpr: 'id', displayExpr: 'name' }"
          >
        </dxi-item>
        <dxi-item dataField="date" editorType="dxDateBox"></dxi-item>
        <dxi-item>
          <div *dxTemplate class="text-end">
            <button type="button" class="btn btn-sm btn-secondary" (click)="addLine()" style="margin-top: 30px;">Add Line</button>
          </div>
        </dxi-item>
        <dxi-item [colSpan]="2">
          <div *dxTemplate>
            <dx-data-grid [dataSource]="pledge.lines" [keyExpr]="'id'" height="275px" [sorting]="'none'">
              <dxi-column dataField="expectedDate" [sortIndex]="0" [sortOrder]="'asc'" calculateSortValue="sortValue"></dxi-column>
              <dxi-column dataField="amount" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
              <dxo-editing mode="cell" [allowUpdating]="true" [selectTextOnEditStart]="true" [startEditAction]="'click'"> </dxo-editing>
            </dx-data-grid>
          </div>
        </dxi-item>
        <dxi-item dataField="nelandInEstate" [label]="{text: 'In Estate'}" ></dxi-item>
        <dxi-item dataField="contactRegardingRetirementAccounts"></dxi-item>
        <dxi-item dataField="note" editorType="dxTextArea" [colSpan]="2"></dxi-item>
      </dx-form>
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-success" (click)="save()">Save</button>
  <button type="button" class="btn btn-default" (click)="cancel()">Cancel</button>
</div>
